import { useEffect } from 'react';
import {
  SidebarItem,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';
import { errorApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import useAsync from 'react-use/lib/useAsync';
import {
  DEFAULT_WORKFLOW_OWNER,
  getWorkflowOwners,
  workflowOwnerTitle,
  workflowOwnerUrl,
} from '../scaffolder/workflowOwners';

export function WorkflowSidebarItem() {
  const catalogApi = useApi(catalogApiRef);
  const errorApi = useApi(errorApiRef);
  const { value: owners = [DEFAULT_WORKFLOW_OWNER], error } =
    useAsync(async () => {
      // The catalog applies the signed-in user's entity read permissions, including
      // shared access. Membership alone does not describe workflow access.
      const { items } = await catalogApi.getEntities({
        filter: { kind: 'Template' },
        fields: [
          'kind',
          'metadata.name',
          'metadata.namespace',
          'spec.owner',
          'relations',
        ],
      });
      return getWorkflowOwners(items);
    }, [catalogApi]);

  useEffect(() => {
    if (error) errorApi.post(error);
  }, [error, errorApi]);

  return (
    <SidebarItem
      icon={BusinessCenterIcon}
      to={workflowOwnerUrl(DEFAULT_WORKFLOW_OWNER)}
      text="Workflows"
    >
      {owners.length > 1 && (
        <SidebarSubmenu title="Workflows">
          {owners.map(owner => (
            <SidebarSubmenuItem
              key={owner}
              title={workflowOwnerTitle(owner)}
              to={workflowOwnerUrl(owner)}
            />
          ))}
        </SidebarSubmenu>
      )}
    </SidebarItem>
  );
}
